export class ThinningDataset {

  id: string;
  tree_count: number;
  cluster_count: number;
  flower_count: number;
  clusters_counted_per_tree: number;
  target_fruit_per_tree: number;
  potential_fruit_per_tree: number;

  measurements: any;

  constructor(private fields: any) {
    this.fields = fields;

    // Quick and dirty extend/assign fields to this model
    for (let f in fields) {
      this[f] = fields[f];
    }
  }

}



// WEBPACK FOOTER //
// ./src/models/thinning-dataset.ts